// Presentation mapping only. Lesson identities belong to common/lesson_catalog.py
// in the backend repository; labels and database IDs never select artwork.
const subjects = {
  MATH: { kind: 'math', accent: '#1683d8', background: '#e4f2ff' },
  TURKCE: { kind: 'turkish', accent: '#ba5486', background: '#ffecf3' },
  FEN_BILIMLERI: { kind: 'science', accent: '#298a95', background: '#e5f7fa' },
  ENGLISH: { kind: 'english', accent: '#bd791e', background: '#fff4d9' },
  HAYAT_BILGISI: { kind: 'life', accent: '#1a9a65', background: '#e6faf0' },
  SOSYAL_BILGILER: { kind: 'social', accent: '#7060bc', background: '#efedff' },
  MIXED_HOMEWORK: { kind: 'mixed', accent: '#804de2', background: '#f2ecff' },
};
const fallback = { kind: 'homework', accent: '#637894', background: '#edf2f8' };
const aliases = { FEN: 'FEN_BILIMLERI', SOSYAL: 'SOSYAL_BILGILER' };

export function homeworkIllustration(lessons = []) {
  const codes = new Set(lessons.map(lesson => {
    const code = String(lesson?.code || '').trim().toUpperCase();
    return aliases[code] || code;
  }).filter(Boolean));
  // Distinct IDs also cover multiple custom lessons with missing/unknown codes.
  const identities = new Set(lessons.map(lesson => lesson?.id != null
    ? `id:${lesson.id}` : `code:${String(lesson?.code || '').trim().toUpperCase()}`).filter(id => id !== 'code:'));
  if (codes.has('MIXED_HOMEWORK') || codes.size > 1 || identities.size > 1) return subjects.MIXED_HOMEWORK;
  return subjects[[...codes][0]] || fallback;
}
